import { render, staticRenderFns } from "./PanelHeader.vue?vue&type=template&id=1af7b8a6&scoped=true"
import script from "./PanelHeader.vue?vue&type=script&lang=js"
export * from "./PanelHeader.vue?vue&type=script&lang=js"
import style0 from "./PanelHeader.vue?vue&type=style&index=0&id=1af7b8a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af7b8a6",
  null
  
)

export default component.exports